<template>
<div class="text-center">
  <span class="h4 d-block mb-3">Wybierz z czego ma być złożony raport</span>
  <b-form-group>
    <div>
      <small class="text-danger" v-show="dataErrors.content">Należy wybrać jedną z opcji.</small>
    </div>
    <b-form-radio-group
      buttons
      v-model="formData.content"
      size="lg"
      button-variant="success"
      :options="contents"/>
  </b-form-group>
</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ReportWizardStep1",
  data: function() {
    return {
      dataErrors: {
        content: false
      },
      contents: [
        { text: "Mapa", value: "mapReport" },
        { text: "Dane GIS", value: "gisReport" }
      ]
    };
  },
  props: {
    formData: Object
  },
  computed: {
    ...mapGetters(["historyTab"])
  },
  methods: {
    validate() {
      this.dataErrors.content = !this.formData.content;

      return !this.dataErrors.content;
    },
    getData() {
      return {
        typ_raportu: this.historyTab ? "historyReport" : this.formData.content
      };
    },
    reset() {
      this.formData.content = undefined;
      this.dataErrors.content = false;
    }
  }
};
</script>